import React, { useId, useState } from "react";
import "./CustomInput.css";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { klavyeIleTikla } from "../../utils/a11y"; // FE-78: tıklanabilir öğelerde klavye desteği


const CustomInput = ({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  disabled,
  extraLabel,
  maxLength,
  autoComplete,
  name,
  id,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  // FE-79 (21.10.2026): etiket ile alan bağlı değildi (ekran okuyucu alanı adsız okuyordu, etikete tıklamak
  // alanı odaklamıyordu). useId ile benzersiz id + label htmlFor.
  const otoId = useId();
  const inputId = id || `ci-${otoId}`;

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  // Telefon maskesi
  const maskPhone = (raw) => {
    if (!raw) return "";
    if (raw.length <= 2) return raw;
    return raw.slice(0, 2) + "*".repeat(raw.length - 2);
  };

  // Sadece telefon input'ta okunabilir, tuşlara manuel müdahale ediyoruz
  const handleKeyDown = (e) => {
    if (type !== "phone") return;
    e.preventDefault();
    const digit = e.key;
    if (/^[0-9]$/.test(digit)) {
      if (value.length < maxLength) onChange({ target: { value: value + digit } });
    } else if (digit === 'Backspace') {
      onChange({ target: { value: value.slice(0, -1) } });
    }
  };

  const handlePaste = (e) => {
    if (type !== "phone") return;
    e.preventDefault();
    const pasted = e.clipboardData.getData('Text').replace(/\D/g, '');
    const allowed = pasted.slice(0, maxLength - value.length);
    if (allowed) onChange({ target: { value: value + allowed } });
  };

  // Telefon hatası
  const hasPhoneError = type === "phone" && value.startsWith('0');

  return (
    <div className="custom-input-container">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {label && <label className="custom-input-label" htmlFor={inputId}>{label}</label>}
        {extraLabel}
      </div>

      <div className="custom-input-wrapper">
        <input
          id={inputId}
          name={name}
          autoComplete={autoComplete}
          // readOnly={type === "phone"}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          type={type === "password" && !isPasswordVisible ? "password" : type === "email" ? "email" : "text"}
          value={type === "phone" ? maskPhone(value) : value}
          onChange={type === "phone" ? () => {} : onChange}
          className="custom-input"
          placeholder={placeholder}
          disabled={disabled}
          maxLength={type === "phone" ? undefined : maxLength}
        />
        {type === "password" && (
          <span role="button" tabIndex={0} onKeyDown={klavyeIleTikla} className="eye-icon" onClick={togglePasswordVisibility}
            aria-label={isPasswordVisible ? "Şifreyi gizle" : "Şifreyi göster"}>
            {isPasswordVisible ? <FiEye /> : <FiEyeOff />}
          </span>
        )}
      </div>

      {hasPhoneError && (
                <span style={{ fontSize: '14px', fontFamily: 'Plus Jakarta Sans', color: '#FF3333',marginTop:'5px',marginLeft:'5px' }}>Lütfen telefon numaranızı başında '0' olmadan giriniz.</span>
      )}
    </div>
  );
};

export default CustomInput;
